import DynamicModal from 'components/DynamicModal';
import React, { useState } from 'react';
import { Button } from 'reactstrap';

import AccountDetailModalContent from './AccountDetailModalContent';

interface Props {
  accountId: number;
  isOpen: boolean;
  isActive: boolean;
  isLoading: boolean;
  accountRowData?: any;
  toggle: () => void;
  handleActivateDeactivateAccount: (
    accountId: number,
    isActive: boolean,
    accountRowData?: any,
  ) => void;
}

const AccountDetailModal: React.FC<Props> = ({
  accountId,
  isActive,
  isOpen,
  isLoading,
  accountRowData,
  toggle,
  handleActivateDeactivateAccount,
}) => {
  const [confirmModalOpen, setConfirmModalOpen] = useState(false);

  const confirmModal = () => {
    return (
      <DynamicModal
        isOpen={confirmModalOpen}
        toggle={() => setConfirmModalOpen(!confirmModalOpen)}
        title={`Confirm ${isActive ? 'Deactivation' : 'Activation'}`}
        content={
          <div>
            <p>
              Are you sure you want to {isActive ? 'deactivate' : 'activate'}{' '}
              this account?
            </p>
          </div>
        }
        size="sm"
        footerActions={
          <>
            <Button
              color="secondary"
              onClick={() => setConfirmModalOpen(!confirmModalOpen)}
            >
              Cancel
            </Button>
            <Button
              color="danger"
              disabled={isLoading}
              onClick={() => {
                handleActivateDeactivateAccount(
                  accountId,
                  !isActive,
                  accountRowData,
                );
                setConfirmModalOpen(!confirmModalOpen);
              }}
            >
              Confirm
            </Button>
          </>
        }
      />
    );
  };

  return (
    <>
      <DynamicModal
        isOpen={isOpen}
        toggle={toggle}
        title="Account Details"
        content={
          <AccountDetailModalContent id={accountId} isActive={isActive} />
        }
        footerActions={
          <>
            <Button color="secondary" onClick={toggle}>
              Cancel
            </Button>
            {isActive ? (
              <Button
                color="danger"
                disabled={isLoading}
                onClick={() => setConfirmModalOpen(!confirmModalOpen)}
              >
                Deactivate
              </Button>
            ) : (
              <Button
                color="primary"
                disabled={isLoading}
                onClick={() => setConfirmModalOpen(!confirmModalOpen)}
              >
                Activate
              </Button>
            )}
          </>
        }
      />
      {confirmModal()}
    </>
  );
};

export default AccountDetailModal;
